<template>
  <div>
    <vs-button
      color="#32C040"
      icon="add_box"
      style="border-radius: 20px"
      v-b-modal.Add_Field
    >
      Add Field
    </vs-button>

    <b-modal
      id="Add_Field"
      centered
      size="lg"
      ok-variant="primary"
      :key="AddFieldState"
      :ok-disabled="addFieldOKbtnState"
      @ok="handleOk"
      @hidden="resetModal"
    >
      <template #modal-header-close>
        <vs-button
          icon="close"
          style="border-radius: 20px"
          color="red"
        ></vs-button>
      </template>

      <template #modal-title>
        <p style="font-size: 18px; margin: auto; font-weight: 400">
          Add Field 
        </p>
        <p style="font-size: 14px; margin-bottom: auto">
          Create a custom new field or select a suggested field you have used
          before.
        </p>
      </template>

      <template>
        <vs-tabs>
          <vs-tab label="Create New Field">
            <p style="margin: auto; padding: 1em 0em">
              <b>Name</b> of the information to be tracked
            </p>

            <vs-input
              v-model="nameAttr"
              placeholder="Name"
              style="width: 100%"
              :warning="nameAttrWarningState"
              :warning-text="warningText"
            />

            <p style="margin: auto; padding: 1em 0em">
              <b>Type</b> of information
            </p>

            <ul class="leftx">
              <li>
                <vs-radio v-model="type" vs-name="attrTypeName" vs-value="Text"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    keyboard_alt
                  </span>
                  <span style="padding-left: 0.5em">Text</span></vs-radio
                >
              </li>

              <li>
                <vs-radio
                  v-model="type"
                  vs-name="attrTypeName"
                  vs-value="Number"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    tag
                  </span>
                  <span style="padding-left: 0.5em">Number</span></vs-radio
                >
              </li>
              <li>
                <vs-radio v-model="type" vs-name="attrTypeName" vs-value="Date">
                  <span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    calendar_today
                  </span>
                  <span style="padding-left: 0.5em">Date</span>
                </vs-radio>
              </li>
              <li>
                <vs-radio
                  v-model="type"
                  vs-name="attrTypeName"
                  vs-value="Currency"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    paid </span
                  ><span style="padding-left: 0.5em">Currency</span></vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="type"
                  vs-name="attrTypeName"
                  vs-value="Dropdown"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    format_list_numbered </span
                  ><span style="padding-left: 0.5em">Dropdown</span></vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="type"
                  vs-name="attrTypeName"
                  vs-value="Picture"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    calendar_today </span
                  ><span style="padding-left: 0.5em">Pictures</span></vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="type"
                  vs-name="attrTypeName"
                  vs-value="Document"
                  ><span
                    class="material-icons-outlined"
                    style="line-height: 1em; font-size: 1em"
                  >
                    upload_file </span
                  ><span style="padding-left: 0.5em">Documents</span></vs-radio
                >
              </li>
            </ul>
          </vs-tab>

          <vs-tab label="Existing Fields">
            <vs-row class="mb-4">
              <b class="mt-3">Suggested Fields</b>
              <vs-spacer />
              <vs-input
                icon-after="true"
                icon="search"
                placeholder="What are you looking for?"
                v-model="value1"
              />
            </vs-row>
            <vs-card
              v-for="(item, index) in fields"
              :key="index"
              actionable
              style="
                width: 100%;
                height: 45px;
                margin-bottom: 10px;
                border-radius: 10px;
              "
            >
              <vs-row>
                <vs-icon
                  color="primary"
                  :icon="icon[item.Type_id - 1]"
                  class="mr-4"
                ></vs-icon>
                <p>{{ item.fieldName }}</p>
              </vs-row>
            </vs-card>
          </vs-tab>
        </vs-tabs>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "axios";

export default {
  props: {
    assetID: Number,
  },
  data() {
    return {
      AddFieldState: 0,
      assetID: "",
      addFieldOKbtnState: true,
      nameAttr: "",
      nameAttrWarningState: false,
      nameAttrDangerState: false,
      type: "Text",
      warningText: "",
      icon: ["text_fields", "format_list_numbered", "check_circle"],
      typefield: [
        { TypeName: "Text", Type_id: 1 },
        { TypeName: "Number", Type_id: 2 },
        { TypeName: "Boolean", Type_id: 3 },
      ],
      fields: [
        { fieldName: "Unit", Type_id: 1 },
        { fieldName: "Qty", Type_id: 2 },
        { fieldName: "Check", Type_id: 3 },
      ],
    };
  },
  watch: {
    nameAttr: function (val) {
      this.validation(val);
    },
  },
  computed: {},
  methods: {
    validation(val) {
      val = val.trim();
      switch (val) {
        case "true" || true:
          this.addFieldOKbtnState = true;
          this.nameAttrWarningState = true;
          this.warningText = "deny value true or false";
          break;
        case "false" || false:
          this.addFieldOKbtnState = true;
          this.nameAttrWarningState = true;
          this.warningText = "deny value true or false";
          break;
        case "":
          this.addFieldOKbtnState = true;
          this.nameAttrWarningState = true;
          this.warningText = "input can not be empty";
          break;
        case null:
          this.addFieldOKbtnState = true;
          this.nameAttrWarningState = true;
          this.warningText = "input can not be empty";
          break;
        default:
          this.addFieldOKbtnState = false;
          this.nameAttrWarningState = false;
          this.warningText = "";
      }
    },
    handleOk() {
      switch (this.type) {
        case "Text":
          this.addAttrAssetText();
          break;
        case "Number":
          this.addAttrAssetNumber();
          break;
        case "Date":
          this.addAttrAssetDate();
          break;
        case "Currency":
          this.addAttrAssetCurrency();
          break;
        case "Dropdown":
          this.addAttrAssetDropdown();
          break;
        case "Picture":
          this.addAttrAssetPicture();
          break;
        case "Document":
          this.addAttrAssetDocument();
          break;
        default:
        // code block
      }
    },
    async addAttrAssetText() {
      await ax
        .post(`${this.$url2}asset/new-textattr-asset`, {
          assetID: this.assetID,
          assetFieldTextName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetNumber() {
      await ax
        .post(`${this.$url2}asset/new-numattr-asset`, {
          assetID: this.assetID,
          assetFieldNumCusName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetDate() {
      await ax
        .post(`${this.$url2}asset/new-dateattr-asset`, {
          assetID: this.assetID,
          assetFieldDateCusName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetCurrency() {
      await ax
        .post(`${this.$url2}asset/new-curattr-asset`, {
          assetID: this.assetID,
          assetFieldCURCusName: this.nameAttr,
          assetFieldCURISOCode: "THB",
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetDropdown() {
      await ax
        .post(`${this.$url2}asset/new-dropdownattr-asset`, {
          assetID: this.assetID,
          assetFieldDropdownName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetPicture() {
      await ax
        .post(`${this.$url2}asset/new-picattr-asset`, {
          assetID: this.assetID,
          picName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    async addAttrAssetDocument() {
      await ax
        .post(`${this.$url2}asset/new-docattr-asset`, {
          assetID: this.assetID,
          docName: this.nameAttr,
        })
        .then((res) => {
          this.notifyCreatedSuccessfuly(res.data.message);
        })
        .catch((error) => {
          this.notifyCreatedError(error.response.data.message);
        });
    },
    notifyCreatedSuccessfuly(message) {
      this.$vs.notify({
        color: "success",
        title: "created successfuly",
        text: message,
        position: "top-center",
      });
    },
    notifyCreatedError(message) {
      this.$vs.notify({
        color: "danger",
        title: "error",
        text: message,
        position: "top-center",
      });
    },
    resetModal() {
      this.type = "Text";
      this.nameAttr = "";
      this.AddFieldState++;
      console.log(" this.AddFieldState : ", this.AddFieldState);
    },
  },
};
</script>

<style>
span.span-text-validation {
  font-size: 1.25em !important;
}
</style>

<style scoped>
.vuesax-app-is-ltr .includeIcon {
  float: none;
  margin-left: 2%;
}

.con-vs-radio {
  align-items: left;
  -webkit-box-align: left;
  -webkit-box-pack: left;
  justify-content: left;
}
</style>
